module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "home"
  }, [_vm._h('home-slider'), " ", " ", _vm._h('home-servicios'), " ", " ", _vm._h('div', {
    attrs: {
      "id": "suscripcion"
    }
  }, [_vm._h('div', {
    staticClass: "container"
  }, [_vm._h('div', {
    staticClass: "row"
  }, [_vm._m(0), " ", _vm._h('div', {
    staticClass: "col-md-6"
  }, [_vm._h('div', {
    staticClass: "input-group centrado"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mail),
      expression: "mail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "e-mail"
    },
    domProps: {
      "value": _vm._s(_vm.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mail = $event.target.value
      }
    }
  }), " ", _vm._h('span', {
    staticClass: "input-group-btn"
  }, [_vm._h('button', {
    staticClass: "btn btn-outline-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.enviarSuscripcion
    }
  }, ["SUSCRIBIRME"])])])])])])]), " ", " ", _vm._h('blog')])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "col-md-6"
  }, [_vm._h('div', [_vm._h('h2', {
    staticClass: "align-middle"
  }, ["Ingrese su mail y reciba más info"])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c8ea6c68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 70
// module chunks = 1